function update_cart() {
  window.location.href = "/cart";
}
document.querySelectorAll(".bundle-atc").forEach((button) => {
  button.addEventListener("click", async () => {
    const timeStamp = Date.now();
    const activeProductData = UpdateBundle();

    let formData = {
      items: [],
    };

    const totalProducts = activeProductData.length;

    activeProductData
      .filter((product) => product.index !== 0)
      .sort((a, b) => b.index - a.index)
      .forEach((product, index) => {
        formData.items.push({
          id: product.id,
          quantity: product.quantity,
          properties: {
            [`${addons_property_label}`]: `${timeStamp}`,
            _initial_quantity: product.quantity,
            Bundle: bundle_title,
            _free: product.free,
          },
        });
      });

    console.log("formData");
    const mainBundle = activeProductData.find((product) => product.index === 0);
    if (mainBundle) {
      formData.items.push({
        id: mainBundle.id,
        quantity: mainBundle.quantity,
        properties: {
          [`${main_product_property_label}`]: `${timeStamp}`,
          [`${number_of_addons_label}`]: `${totalProducts}`,
          _initial_quantity: mainBundle.quantity,
          Bundle: bundle_title,
        },
      });
    }

    try {
      console.log(formData);
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      console.log("Cart updated:", result);
      update_cart();
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  });
});

const UpdateBundle = () => {
  const activeProducts = document.querySelectorAll(".bundle-product.active");
  const mainBundle = document.querySelector(".main-bundle");
  const bundleLimitNumberSelected = document.querySelector(
    ".bundle-limit-number-selected"
  );
  const bundleAtcButtons = document.querySelectorAll(".bundle-atc");
  const plusButtons = document.querySelectorAll(
    ".quantity-selector__button:last-child"
  );

  let activeProductCount = 0;
  let totalPrice = 0;
  let totalComparePrice = 0;

  const activeProductData = [];

  if (mainBundle) {
    const mainBundleQuantity = 1;
    const mainBundlePrice = parseInt(mainBundle.dataset.price, 10) || 0;
    const mainBundleComparePrice =
      parseInt(mainBundle.dataset.compare, 10) || 0;

    totalPrice += mainBundlePrice * mainBundleQuantity;
    totalComparePrice += mainBundleComparePrice * mainBundleQuantity;
    activeProductCount += mainBundleQuantity;

    activeProductData.push({
      id: mainBundle.dataset.vid,
      quantity: mainBundleQuantity,
      price: mainBundlePrice,
      comparePrice: mainBundleComparePrice,
      index: 0,
      free: "no",
    });
  }

  const bundleProducts = document.querySelectorAll(
    ".bundle-products .bundle-product.active"
  );
  const bundleFreeProducts = document.querySelectorAll(
    ".bundle-free-products .bundle-product.active"
  );

  bundleProducts.forEach((product, index) => {
    const quantity = parseInt(product.dataset.qty, 10) || 0;
    const price = parseInt(product.dataset.price, 10) || 0;
    const comparePrice = parseInt(product.dataset.compare, 10) || 0;

    totalPrice += price * quantity;
    totalComparePrice += comparePrice * quantity;
    activeProductCount += quantity;

    activeProductData.push({
      id: product.dataset.vid,
      quantity,
      price,
      comparePrice,
      index: index + 1,
      free: "no",
    });
  });

  bundleFreeProducts.forEach((product, index) => {
    const quantity = parseInt(product.dataset.qty, 10) || 0;
    const price = parseInt(product.dataset.price, 10) || 0;
    const comparePrice = parseInt(product.dataset.compare, 10) || 0;

    totalPrice += price * quantity;
    totalComparePrice += comparePrice * quantity;
    activeProductCount += quantity;

    activeProductData.push({
      id: product.dataset.vid,
      quantity,
      price,
      comparePrice,
      index: bundleProducts.length + index + 1,
      free: "yes",
    });
  });

  if (bundleLimitNumberSelected) {
    bundleLimitNumberSelected.textContent =
      activeProductCount - free_products_count;
  }

  const savingsPercentage =
    totalComparePrice > 0
      ? ((totalComparePrice - totalPrice) / totalComparePrice) * 100
      : 0;

  const savings = savings_text.replace(
    "{{ savings }}",
    `${Math.round(savingsPercentage)}%`
  );

  document
    .querySelectorAll(".bundle-price-price")
    .forEach(
      (el) =>
        (el.textContent = `${(totalPrice / 100).toFixed(
          2
        )} ${current_currency}`)
    );

  document
    .querySelectorAll(".bundle-price-compareat-price")
    .forEach(
      (el) =>
        (el.textContent = `${(totalComparePrice / 100).toFixed(
          2
        )} ${current_currency}`)
    );

  document
    .querySelectorAll(".bundle-price-savings span")
    .forEach((el) => (el.textContent = savings));

  if (activeProductCount >= bundle_limit) {
    plusButtons.forEach((button) => (button.disabled = true));
  } else {
    plusButtons.forEach((button) => (button.disabled = false));
  }

  if (activeProductCount === bundle_limit) {
    bundleAtcButtons.forEach((button) => {
      button.removeAttribute("disabled");
      button.innerHTML = button_text;
    });
  } else {
    bundleAtcButtons.forEach((button) => {
      button.setAttribute("disabled", "true");
      button.innerHTML = button_text_before+`(${activeProductCount - free_products_count}/${bundle_limit_text})`;
    });
  }

  return activeProductData;
};

document.addEventListener("DOMContentLoaded", UpdateBundle);

const updateBundleProduct = (input, bundleProduct) => {
  const value = parseInt(input.value, 10) || 0;
  if (value >= 1) {
    bundleProduct.classList.add("active");
  } else {
    bundleProduct.classList.remove("active");
  }
  bundleProduct.dataset.qty = value;

  UpdateBundle();
};

document
  .querySelectorAll(".bundle-product .quantity-selector")
  .forEach((selector) => {
    const input = selector.querySelector("input");
    const bundleProduct = selector.closest(".bundle-product");

    if (!bundleProduct) return;

    input.addEventListener("input", () => {
      setTimeout(() => updateBundleProduct(input, bundleProduct), 0);
    });

    selector.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", () => {
        setTimeout(() => updateBundleProduct(input, bundleProduct), 0);
      });
    });
  });
